import * as tslib_1 from "tslib";
import { all, put, select } from 'redux-saga/effects';
import { initBrowseStream, deselectAll, unsetCurrentFolderId, initGallectionDeviationStream, } from '../actions';
import { MediaSourceType } from '../types';
import { getCurrentMediaSource } from '../selectors';
export default function () {
    var mediaSource, actionsToPut;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _a.sent();
                actionsToPut = [deselectAll(), unsetCurrentFolderId()];
                if (mediaSource === MediaSourceType.GALLERY) {
                    actionsToPut.push(initGallectionDeviationStream());
                }
                else if (mediaSource === MediaSourceType.BROWSE) {
                    actionsToPut.push(initBrowseStream());
                }
                return [4 /*yield*/, all(actionsToPut.map(function (actionToPut) { return put(actionToPut); }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=setSearchQuery.js.map